import { FlexRow } from '@components/FlexRow';
import Colors from '@constants/Colors';
import { Typography, useTheme } from '@mui/material';
import React from 'react'

type Props = {
    isPublished?: boolean;
    isDraft?: boolean;
}

const BlogStatus = (props: Props) => {
    const theme = useTheme();
    
    if (props.isDraft) {
        return <FlexRow sx={{ gap: 0, alignItems: "center" }}>
            <i className='fi fi-ss-bullet' style={{ marginTop: 6, marginLeft: -6, marginRight: 3, color: "#F2D74A" }}></i>
            <Typography style={{
                color: theme.palette.mode === 'light' ? "#242333" : "var(--text-primary, #FFF)",
                textAlign: "center",
                fontFamily: "var(--font-family-Core, Plus Jakarta Sans)",
                fontSize: "var(--font-size-sm, 13px)",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "var(--font-line-height-xs, 16px)",
            }}>Brouillon</Typography>
        </FlexRow>
    }


    if (props.isPublished) {
        return <FlexRow sx={{ gap: 0, alignItems: "center" }}>
            <i className='fi fi-ss-bullet' style={{ marginTop: 6, marginLeft: -6, marginRight: 3, color: Colors.SUCCESS_GREEN }}></i>
            <Typography style={{
                color: theme.palette.mode === 'light' ? "#242333" : "var(--text-primary, #FFF)",
                textAlign: "center",
                fontFamily: "var(--font-family-Core, Plus Jakarta Sans)",
                fontSize: "var(--font-size-sm, 13px)",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "var(--font-line-height-xs, 16px)",
            }}>Publié</Typography>
        </FlexRow>
    }

    return (
        <FlexRow sx={{ gap: 0, alignItems: "center" }}>
            <i className='fi fi-ss-bullet' style={{ marginTop: 6, marginLeft: -6, marginRight: 3, color: "#F2D74A" }}></i>
            <Typography style={{
                color: theme.palette.mode === 'light' ? "#242333" : "var(--text-primary, #FFF)",
                textAlign: "center",
                fontFamily: "var(--font-family-Core, Plus Jakarta Sans)",
                fontSize: "var(--font-size-sm, 13px)",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "var(--font-line-height-xs, 16px)",
            }}>Non publié</Typography>
        </FlexRow>
    )
}

export default BlogStatus
